type RGBA = {
  r: number;
  g: number;
  b: number;
  a: number;
};

const clamp = (value: number) => Math.max(0, Math.min(255, value));

const toHex = (num: number) => num.toString(16).padStart(2, "0");

const hexToRgba = (hex: string, alpha = 1): RGBA => {
  hex = hex.replace("#", "");

  // Expand shorthand (#fff → #ffffff)
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }

  if (![6, 8].includes(hex.length)) {
    return { r: 0, g: 0, b: 0, a: alpha };
  }

  const bigint = parseInt(hex.slice(0, 6), 16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  if (hex.length === 8) {
    alpha = parseInt(hex.slice(6, 8), 16) / 255;
  }

  return { r, g, b, a: alpha };
};

export const generateColorStyles = (
  baseColor: string,
  increment: number,
  isStyle = true,
) => {
  const { r, g, b, a } = hexToRgba(baseColor);

  if (isStyle) {
    return {
      backgroundColor: `rgba(${clamp(r + increment)}, ${clamp(g + increment)}, ${clamp(
        b + increment,
      )}, ${a})`,
    };
  } else {
    const newR = clamp(r + increment);
    const newG = clamp(g + increment);
    const newB = clamp(b + increment);
    const newA = a; // Alpha remains unchanged

    return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}${toHex(Math.round(newA * 255))}`;
  }
};
